export let initialState = {
  followedPrograms: [],
  loading: false,
}

// Alias for compatibility
export const InitialState = initialState
